import React from 'react';
import { observer, inject } from 'mobx-react';
import { Grid, withStyles, Paper, Select, MenuItem, Button, FormHelperText, Typography } from '@material-ui/core';
import FormInputLabel from '../../components/FormInputLabelView';
import PageTitle from '../../components/PageTitle/PageTitle';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Loader from '../../components/Loader/LoaderView';
import { withTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { clearLocalStorage } from '../../utils/common';

class ViewManager extends React.Component {
  constructor(props) {
    super(props);
    this.goBack = this.goBack.bind(this);
    // this.initData = this.initData;
    this.state = {
      tenantPermission: [],
      expandIndex: null,
      groupslist: [],
      data: {
        locationId: '',
      },
      errorField: {
        locationId: false,
      },
      isCheckAll: false,
    };
  }

  async componentDidMount() {
    await this.props.locations.getLocationList(0, 0);
    await this.props.group.getGroupList();

    const userPath = this.props.location.pathname.replace('/app/users/', '');
    const userId = Number(userPath.replace('/manage', ''));

    await this.props.user.getUserById(userId);
    this.initData();
  }

  async initData() {
    const { userDetail } = this.props.user.toJS();
    const tenantPermission = JSON.parse(userDetail.tenantPermission);
    this.setState({ tenantPermission });

    let groupPermission = JSON.parse(userDetail.groupPermission);
    let subgroupPermission = JSON.parse(userDetail.subgroupPermission);
    if (userDetail.locationPermission) {
      let locationPermission = JSON.parse(userDetail.locationPermission);
      const locationId = locationPermission.find((item) => item) || 0;
      if (locationId) {
        this.setState({
          data: {
            locationId: locationId,
          },
        });
      }
      await this.props.group.getGroupByLocationId(locationId);
    }
    let { groupsList } = this.props.group.toJS();

    groupsList = groupsList
      .filter((val) => tenantPermission.includes(val.tenantId))
      .map((g) => {
        let count = 0;
        if (groupPermission.includes(g.id)) {
          const subgroups = (g.subGroups || []).filter(
            (s) => subgroupPermission.length === 0 || subgroupPermission.includes(s.id),
          );
          if (subgroups.length > 0) {
            g.subGroups.map((s) => {
              s.status = subgroups.find((value) => value.id === s.id) ? true : false;
              if (s.status === true) {
                count++;
              }
              return s;
            });
          } else {
            g.subGroups.map((s) => {
              s.status = true;
              if (s.status === true) {
                count++;
              }
              return s;
            });
          }
        }
        g.status = count === g.subGroups.length ? true : false;
        g.countSubgroup = count;
        return g;
      });

    this.setState({
      groupslist: groupsList,
      isCheckAll:
        groupsList && groupsList.length === (groupsList || []).filter((group) => group.status === true).length
          ? true
          : false,
    });
  }

  handleChangeLocations = async (e) => {
    const { name, value } = e.target;
    this.clearErrorField(name);
    this.setState((prevState) => {
      prevState.data[name] = value;
      return prevState;
    });
    await this.props.group.getGroupByLocationId(value);
    const { tenantPermission } = this.state;
    let { groupsList } = this.props.group.toJS();
    groupsList = groupsList
      .filter((val) => tenantPermission.includes(val.tenantId))
      .map((val) => {
        val.status = false;
        val.countSubgroup = 0;
        val.subGroups.map((item) => {
          item.status = false;
          return item;
        });
        return val;
      });
    this.setState({
      groupslist: groupsList,
      isCheckAll: false,
    });
  };

  validate() {
    const { data } = this.state;
    if (!data.locationId) {
      let checkLocation = !data.locationId ? true : false;
      this.setState({
        errorField: {
          locationId: checkLocation,
        },
      });
      return false;
    } else {
      this.setState({
        errorField: {
          locationId: false,
        },
      });
    }
    return true;
  }

  clearErrorField(key) {
    if (key === 'locationId') {
      this.setState({
        ...this.state,
        errorField: {
          ...this.state.errorField,
          locationId: false,
        },
      });
    }
  }

  goBack() {
    this.props.user.setAction('action', true);
    this.props.history.goBack();
  }

  expandList = (index) => {
    this.setState((prevState) => {
      prevState.expandIndex = prevState.expandIndex !== index ? (prevState.expandIndex = index) : null;
      return prevState;
    });
  };

  handleSelectAll = (e) => {
    let { groupslist } = this.state;
    groupslist.map((group) => {
      group.status = e.target.checked ? true : false;
      group.countSubgroup = e.target.checked ? group.subGroups.length : 0;
      group.subGroups.map((subgroup) => {
        subgroup.status = e.target.checked ? true : false;
        return subgroup;
      });
      return group;
    });
    this.setState({
      isCheckAll: e.target.checked,
      groupslist: groupslist,
    });
  };

  handleChange = (e) => {
    let groups = this.state.groupslist;
    const expand = this.state.expandIndex;
    const { value, name, checked } = e.target;
    let newArr = [];
    if (name === 'group') {
      groups.map((val) => {
        if (+val.id === +value) {
          val.status = checked;
          (val.subGroups || []).map((item) => {
            item.status = val.status ? true : false;
            return item;
          });
          val.countSubgroup = checked ? val.subGroups.length : 0;
        }
        return val;
      });
    }
    if (name === 'module') {
      groups.map((val) => {
        if (+val.id === +expand) {
          (val.subGroups || []).map((item) => {
            if (+item.id === +value) {
              item.status = checked ? true : false;
            }
            if (item.status === true) {
              newArr.push(item.id);
            }
            return item;
          });
          const findSubgroup = val.subGroups.find((item) => item.status === false);
          val.status = findSubgroup ? false : true;
          val.countSubgroup = newArr.length;
        }
        return val;
      });
    }

    const hasStatus = groups.filter((item) => item.status === true);
    this.setState({
      ...this.state,
      groupslist: groups,
      isCheckAll: hasStatus.length === groups.length ? true : false,
    });
  };

  handleSave = (id) => {
    const { t } = this.props;
    if (this.validate()) {
      Swal.fire({
        html: `<h4>${t('manage_views')}`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: `${t('update')}`,
        cancelButtonText: `${t('cancel')}`,
        reverseButtons: true,
        customClass: {
          container: 'my-swal',
        },
      }).then(async (result) => {
        if (result.value) {
          let { groupslist, data } = this.state;
          const perLocation = [];
          perLocation.push(data.locationId);

          const perGroup = [];
          let perSubGroup = [];
          let flag = false;

          (groupslist || []).map((val) => {
            flag = false;
            let subgroupResults = [];
            (val.subGroups || []).forEach((item) => {
              if (item.status === true) {
                subgroupResults.push(item.id);
                flag = true;
              }
            });

            subgroupResults = val.subGroups.length === subgroupResults.length ? [] : subgroupResults;
            perSubGroup = perSubGroup.concat(subgroupResults);

            if (flag === true) {
              perGroup.push(val.id);
            }

            return val;
          });

          data.id = id;
          data.groupPermission = perGroup;
          data.subgroupPermission = perSubGroup;
          data.locationPermission = perLocation;
          try {
            const result = await this.props.user.updateUser(data);
            if (result.statusCode === 200) {
              Swal.fire({ html: `<h4>${t('update_success')}`, type: 'success' }).then(async (resultSuccess) => {
                if (resultSuccess.value) {
                  this.props.user.setAction('action', true);
                  this.props.history.push('../../users');
                } else {
                  Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
                }
              });
            }
          } catch (e) {
            if (e.statusCode === 401) {
              clearLocalStorage();
              window.location.href = '/login';
            } else {
              Swal.fire({ html: `<h4>${t('failed_to_update')}`, type: 'error' });
            }
          }
        }
      });
    }
  };

  render() {
    const { classes, t } = this.props;
    let { groupslist, data, isCheckAll } = this.state;
    const { locations, loading } = this.props.locations.toJS();
    const groups = this.props.group.toJS();

    const userPath = this.props.location.pathname.replace('/app/users/', '');
    const userId = Number(userPath.replace('/manage', ''));

    return (
      <React.Fragment>
        <Loader loading={loading || groups.loading} />
        <Paper className={classes.paper}>
          <PageTitle title={t('manage_view')} />
          <Grid container spacing={16} className={classes.wrapContain}>
            <Grid item xs={12} sm={2}>
              <FormInputLabel label={t('location')} required />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Paper className={`${classes.root} selectInput ${classes.spaceTop}`}>
                <Select
                  value={data.locationId || 0}
                  onChange={this.handleChangeLocations}
                  inputProps={{
                    name: 'locationId',
                    id: 'locationId',
                  }}
                >
                  <MenuItem fullwidth='true' key={0} value={0}>
                    {t('please_select_location')}
                  </MenuItem>
                  {(locations.data || []).map((val) => (
                    <MenuItem fullwidth='true' key={val.id} value={val.id}>
                      {`${val.name || ''}`}
                    </MenuItem>
                  ))}
                </Select>
              </Paper>
              <FormHelperText
                error
                hidden={!data.reset ? !this.state.errorField.locationId : true}
                id='  component-error-text'
              >
                {t('required_field')}
              </FormHelperText>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              className={classes.mainContain}
              style={{ display: groupslist.length === 0 ? 'none' : '' }}
            >
              <div className={classes.headCard}>
                <FormControlLabel
                  aria-label='selectAll'
                  onClick={(event) => event.stopPropagation()}
                  onFocus={(event) => event.stopPropagation()}
                  control={
                    <Checkbox
                      name='selectAll'
                      id='selectAll'
                      onChange={(e) => this.handleSelectAll(e)}
                      color='primary'
                      checked={isCheckAll ? true : false}
                    />
                  }
                  label={t('select_all_groups')}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={12} className={classes.listContain}>
              <div className={classes.expandRoot}>
                {(groupslist || []).map((val) => (
                  <ExpansionPanel
                    className={classes.expansionPanel}
                    onChange={this.expandList.bind(null, val.id)}
                    expanded={this.state.expandIndex === val.id}
                    key={'expension' + val.id}
                  >
                    <ExpansionPanelSummary
                      className={classes.expansionPanelSummary}
                      expandIcon={<ExpandMoreIcon />}
                      aria-label='Expand'
                      aria-controls='additional-actions1-content'
                      id={`expand-panel-group-${val.id}`}
                    >
                      <FormControlLabel
                        aria-label='group'
                        onClick={(event) => event.stopPropagation()}
                        onFocus={(event) => event.stopPropagation()}
                        key={val.id}
                        control={
                          <Checkbox
                            onChange={(e) => this.handleChange(e)}
                            value={val.id + ''}
                            name='group'
                            checked={val.status ? true : false}
                            color='primary'
                          />
                        }
                        label={
                          <Typography>
                            {val.name} <br /> {val.countSubgroup ? val.countSubgroup : 0} / {val.subGroups.length}{' '}
                            {t('selected')}
                          </Typography>
                        }
                      />
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails
                      className={classes.expansionPanelDetails}
                      style={{ display: val.subGroups.length === 0 ? 'none' : '' }}
                    >
                      <Grid container spacing={16}>
                        {(val.subGroups || []).map((item) => (
                          <Grid item xs={12} sm={4} key={'detail' + item.id}>
                            <FormControlLabel
                              aria-label='subgroup'
                              className={classes.bodyMargin}
                              onClick={(event) => event.stopPropagation()}
                              onFocus={(event) => event.stopPropagation()}
                              control={
                                <Checkbox
                                  key={item.id}
                                  onChange={(e) => this.handleChange(e)}
                                  value={item.id + ''}
                                  name='module'
                                  checked={item.status ? true : false}
                                  color='primary'
                                />
                              }
                              label={item.name}
                            />
                          </Grid>
                        ))}
                      </Grid>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                ))}
              </div>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.buttons}>
                <Button className={classes.button} onClick={this.goBack}>
                  {t('back')}
                </Button>
                <Button
                  variant='contained'
                  color='primary'
                  className={classes.button}
                  onClick={() => this.handleSave(userId)}
                >
                  {t('save')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </Paper>
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  spaceTop: {
    marginTop: '10px',
  },
  mainContain: {
    marginTop: '10px',
  },
  listContain: {
    marginLeft: theme.spacing.unit * 5,
  },
  buttons: {
    marginTop: '50px',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginLeft: '5px',
  },
  paper: {
    padding: '24px',
    margin: '30px',
  },
  wrapContain: {
    padding: 20,
  },
  headCard: {
    width: '100%',
    padding: '12px 0px',
  },
  expandRoot: {
    width: '100%',
  },
  expansionPanel: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
    expanded: {},
  },
  expansionPanelSummary: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
    content: {
      '&$expanded': {
        margin: '5px 0',
      },
    },
    expanded: {},
  },
  expansionPanelDetails: {
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    padding: '8px 22px',
  },
  bodyMargin: {
    marginLeft: '20px',
  },
});

export const page = inject('subGroup', 'group', 'locations', 'user')(observer(ViewManager));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
